import {getRequiredError, valid} from "./ValidationChecker";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";

export function selectOnChange(f, t, v, required) {
    valid(required, t, v, f);
    setState(f, t, v);
}

function setState(f, t, v) {
    f((prev) => ({
        ...prev,
        [t]: v,
    }));
}

export function selectSubOnChange(f, t, dto, v, required) {
    // valid(required, t, v, f);

    setSubState(f, dto, t, v);
}

function setSubState(f, dto, t, v) {
    f(prevState => {
        const newState = { ...prevState };
        const obj = {
            [dto.subName]:{id:dto.subId},
            [dto.fieldName]: v,
        };
        const targetArray = [...(newState[t] || [])];
        targetArray[dto.index] = obj;

        newState[t] = targetArray;
        return newState;
    });
}


function getToastMessageByApi(u, updateObj) {
    u(updateObj).then(r => {
            if (r.status === 200) {
                handleActiveToast({
                    description: "", message: "수정 되었습니다.", labelListener: () => {
                    }
                })
            } else if (r.status === 201 || (r.status === 202)) {
                handleActiveError({message: r.data.title, description: r.data.reason});
            } else {
                handleActiveError({message: '처리실패', description: '알수 없는 원인'});
            }
        }
    );
}